/**
 * Sub-frame sampling for the re-keyed skill motions (motions/wx.ts; C0-VFX, ported by C0-VFX-PREP). A motion is drawn
 * at `FRAMES` (14) phases; the wx motions carry 9–30 keys, so they are sampled at quarter frames (eighth frames for the
 * long showcases, `wxSub`) to show every key. Every other motion passes through `motionPhase` unchanged.
 *
 * The renderer takes this in place of `motionPhase` (one import line), so every call site — swings, receives, extras —
 * gets it; the in-between frames are built on first use like any frame not yet in the cache.
 */
import { FRAMES } from './kit';
import { motionPhase, type MotionId } from './index';
import { WX_MOTION_IDS, wxSub } from './wx';

/** A motion's phase at frame `f` (0 to `FRAMES` − 1): whole frames, or `wxSub` steps for the wx motions. */
export function wxPhase(id: MotionId, f: number): number {
  if (!WX_MOTION_IDS.has(id)) return motionPhase(id, f);
  const sub = wxSub(id);
  return motionPhase(id, 0) + Math.round(Math.max(0, Math.min(FRAMES - 1, f)) * sub) / sub;
}
